/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ExamCorrectionGrid200,
  GetApiV1ExamCorrectionGrid400,
  GetApiV1ExamCorrectionGrid401,
  GetApiV1ExamCorrectionGrid500,
  GetApiV1ExamCorrectionGridQueryParams,
  GetApiV1ExamCorrectionGridQueryResponse,
} from "../../types/examCorrectionDashboardController/GetApiV1ExamCorrectionGrid.ts";
import { examItemAnswerTextCorrectionGridItemRepositoryResponsePaginatedResponseSchema } from "../examItemAnswerTextCorrectionGridItemRepositoryResponsePaginatedResponseSchema.ts";

export const getApiV1ExamCorrectionGridQueryParamsSchema = z.object({
  examPublishId: z.optional(z.coerce.number().int()),
  pageNumber: z.coerce.number().int().default(1),
  pageSize: z.coerce.number().int().default(10),
}) as unknown as ToZod<GetApiV1ExamCorrectionGridQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ExamCorrectionGrid200Schema = z.lazy(
  () =>
    examItemAnswerTextCorrectionGridItemRepositoryResponsePaginatedResponseSchema,
) as unknown as ToZod<GetApiV1ExamCorrectionGrid200>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const getApiV1ExamCorrectionGrid400Schema =
  z.any() as unknown as ToZod<GetApiV1ExamCorrectionGrid400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ExamCorrectionGrid401Schema =
  z.any() as unknown as ToZod<GetApiV1ExamCorrectionGrid401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1ExamCorrectionGrid500Schema =
  z.any() as unknown as ToZod<GetApiV1ExamCorrectionGrid500>;

export const getApiV1ExamCorrectionGridQueryResponseSchema = z.lazy(
  () => getApiV1ExamCorrectionGrid200Schema,
) as unknown as ToZod<GetApiV1ExamCorrectionGridQueryResponse>;
